import { createSelector } from 'reselect';
import { IAppState } from 'spw-redux/reducer';
import { currentProject } from '../projects/selectors';
import { selectTeam } from '../teams/selectors';

export const selectTeamJoinRequestsList = (state: IAppState) =>
  state.joinRequestsReducer.teamJoinRequestsList;

/**
 * Selects join requests which the current user is allowed to see.
 * For org admins it is all teams within the org.
 * For team admins it is only teams they are administering.
 */
export const selectAllTeamsJoinRequestsList = (state: IAppState) =>
  state.joinRequestsReducer.allTeamsJoinRequestsList;

export const selectUserPendingTeamRequestsMap = (state: IAppState) =>
  state.joinRequestsReducer.userPendingTeamRequestsMap;

export const selectedUserPendingProjectRequestsMap = (state: IAppState) =>
  state.joinRequestsReducer.userPendingProjectRequestsMap || {};

export const selectLoadingUserPendingProjectRequests = (state: IAppState) =>
  state.joinRequestsReducer.loadingUserPendingProjectRequests;

export const selectUserAlreadySentTeamRequest = createSelector(
  selectTeam,
  selectUserPendingTeamRequestsMap,
  (team, userPendingTeamRequestsMap) => {
    return !!userPendingTeamRequestsMap[team?.id];
  }
);

export const selectUserAlreadySentProjectRequest = createSelector(
  currentProject,
  selectedUserPendingProjectRequestsMap,
  (project, userPendingProjectRequestsMap) => {
    return !!userPendingProjectRequestsMap[project?.id];
  }
);

export const selectProjectJoinRequestsList = (state: IAppState) =>
  state.joinRequestsReducer.projectJoinRequestsList;

export const selectJoinRequestBeingResponded = (state: IAppState) =>
  state.joinRequestsReducer.joinRequestBeingResponded;

export const selectUserProjectsJoinRequestsList = (state: IAppState) =>
  state.joinRequestsReducer.userProjectsJoinRequestsList;

export const selectNotificationRequestTotals = (state: IAppState) =>
  state.joinRequestsReducer.notificationRequestTotals;
